








import Vue from 'vue'
import Component from 'vue-class-component'

import DigitalCurrency8WatchVideoIntroduction from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-8-watch-video-introduction.vue'
import DigitalCurrency13DigitalCurrencyFeatureList from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-13-digital-currency-feature-list.vue'


@Component({
  components: {
    DigitalCurrency8WatchVideoIntroduction,
    DigitalCurrency13DigitalCurrencyFeatureList
  }
})
class AboutHelperComponents2Header extends Vue {

}

export default AboutHelperComponents2Header
